













import Vue from "vue";
import { Component, Prop, Ref } from "vue-property-decorator";

@Component
export default class Title extends Vue {
  @Prop()
  content!: string;

  @Prop()
  titleClass!: string;

  @Prop({ default: "" })
  tooltipContent!: string;

  @Ref("title")
  title!: Node;

  @Ref("titleTooltip")
  titleTooltip!: any;

  copy() {
    let range;

    range = document.createRange();
    range.selectNode(this.title);

    const selection = window.getSelection();

    if (selection) {
      selection.removeAllRanges();
      selection.addRange(range);
      document.execCommand("copy");
      selection.removeAllRanges();
    }

    let originalTooltip = this.titleTooltip.content;
    this.titleTooltip.content = "Copied!";
    setTimeout(() => {
      this.titleTooltip.content = originalTooltip;
    }, 2000);
  }
}
